import { Mary } from "@vwpfs/vwpfs-mary-react-comp-lib";
import { ThemePalette } from "@vwpfs/vwpfs-mary-react-comp-lib/dist/theme";
import React from "react";

interface WarningMessagesProps {
    warnings?: Record<string, string>;
}

export const WarningMessages: React.FC<WarningMessagesProps> = ({ warnings }) => {
    if (!warnings) {
        return null;
    }

    return  (
        <Mary.atoms.Blockquote
            theme={{
                palette: Mary.theme.ThemePalette.CONTRAST_TERTIARY,
                margin: {
                    "": { b: 2 },
                    "sm": { b: 2 },
                },
            }}
            background
            style={{ position: "relative" }}
        >
            <div style={{display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                gap: "3px"}}>
                {Object.values(warnings).map((message, index) => (<React.Fragment key={`${message}${index}`}>
                    <Mary.base.Div theme={{palette: ThemePalette.CONTRAST_TERTIARY}}
                        className="scl-h-foreground--brand-text-body"
                        style={{
                            textTransform: "none",
                            borderRadius: 0,
                            hyphens: "auto",
                            padding: "2px",
                            paddingLeft: "8px",
                            paddingRight: "8px"}}>
                        <b>{message}</b>
                    </Mary.base.Div>
                </React.Fragment>
                ))}
            </div>
        </Mary.atoms.Blockquote>
    );
};
